let API_HOST = '';
if (process.env.VUE_APP_API_HOST) {
    API_HOST = process.env.VUE_APP_API_HOST;
} else if (process.env.APP_ENV === 'production') {
    API_HOST = 'https://api.thecuelist.com';
} else if (process.env.APP_ENV === 'local') {
    API_HOST = 'http://localhost:3000';
} else {
    API_HOST = 'https://staging-api.thecuelist.com';
}

// The Cuelist backend (cuelist-backend on Cloud Run). Read by api-auth-client.js,
// which attaches the user's ID token to every request to it.
const BACKEND_API_HOST = API_HOST;

const SAMPLE_PROJECT_PATH = 'pdfs/Cuelist_Sample_Script.pdf';
const SAMPLE_POSTER_PATH = 'posters/Cuelist_Sample_Poster.png';

const PROJECT_CREATE_SAMPLE_URL = API_HOST + '/pdftk/project_create_sample';

const PROJECT_DELETE_PAGES_URL = API_HOST + '/pdftk/project_delete_pages';
const PROJECT_ADD_PAGES_URL = API_HOST + '/pdftk/project_add_pages';
const PROJECT_REPLACE_PAGES_URL = API_HOST + '/pdftk/project_replace_pages';

const PROJECT_CREATE_VERSION_URL = API_HOST + '/pdftk/project_create_version';
const PROJECT_PROMOTE_VERSION_URL = API_HOST + '/pdftk/project_promote_version';

const SUBSCRIBE_PLAN_URL = API_HOST + '/stripe/subscribe';
const CANCEL_PLAN_URL = API_HOST + '/stripe/cancel';
const CANCEL_PLAN_UNDO_URL = API_HOST + '/stripe/cancel/undo';
const UPDATE_SUBSCRIPTION_URL = API_HOST + '/stripe/update_subscription';
const UPDATE_CARD_URL = API_HOST + '/stripe/update_card';
const UPDATE_EMAIL_URL = API_HOST + '/stripe/update_email';
const CHECK_PROMOCODE_URL = API_HOST + '/stripe/check_promocode';

const GET_INVOICES_URL = API_HOST + '/stripe/get_invoices';

const firebaseProjectId = String(process.env.VUE_APP_FIREBASE_PROJECTID || 'cuelist-staging').replace(/'/g, '');
const DEFAULT_CLOUD_FUNCTIONS_BASE = `https://us-central1-${firebaseProjectId}.cloudfunctions.net/app`;
const CLOUD_FUNCTIONS_BASE = process.env.VUE_APP_CLOUD_FUNCTIONS_BASE || DEFAULT_CLOUD_FUNCTIONS_BASE;
const NOTESLIST_INTEGRATION_LINK_URL = CLOUD_FUNCTIONS_BASE + '/integrations/noteslist/link';
const NOTESLIST_INTEGRATION_UNLINK_URL = CLOUD_FUNCTIONS_BASE + '/integrations/noteslist/unlink';
const NOTESLIST_INTEGRATION_STATUS_URL = CLOUD_FUNCTIONS_BASE + '/integrations/noteslist/status';
const NOTESLIST_ACCOUNT_STATUS_URL = CLOUD_FUNCTIONS_BASE + '/integrations/noteslist/account/status';
const NOTESLIST_ACCOUNT_START_URL = CLOUD_FUNCTIONS_BASE + '/integrations/noteslist/account/start';
const NOTESLIST_ACCOUNT_UNLINK_URL = CLOUD_FUNCTIONS_BASE + '/integrations/noteslist/account/unlink';
const NOTESLIST_PRODUCTIONS_URL = CLOUD_FUNCTIONS_BASE + '/integrations/noteslist/productions';
const NOTESLIST_RESYNC_URL = CLOUD_FUNCTIONS_BASE + '/integrations/noteslist/resync';
const NOTESLIST_NOTIFY_STRUCTURE_URL = CLOUD_FUNCTIONS_BASE + '/integrations/noteslist/notify-structure';
const NOTESLIST_UPGRADE_TO_DUAL_URL =
    CLOUD_FUNCTIONS_BASE + '/integrations/noteslist/billing/upgrade-to-dual';
const NOTESLIST_PREVIEW_SWITCH_URL =
    CLOUD_FUNCTIONS_BASE + '/integrations/noteslist/billing/preview-switch';
const NOTESLIST_APPLY_SWITCH_URL =
    CLOUD_FUNCTIONS_BASE + '/integrations/noteslist/billing/apply-switch';
const NOTESLIST_CONFIRM_SWITCH_URL =
    CLOUD_FUNCTIONS_BASE + '/integrations/noteslist/billing/confirm-switch';
const NOTESLIST_SWITCH_CUELIST_INTERVAL_URL =
    CLOUD_FUNCTIONS_BASE + '/integrations/noteslist/billing/switch-cuelist-interval';
const NOTESLIST_SWITCH_TO_STUDENT_URL =
    CLOUD_FUNCTIONS_BASE + '/integrations/noteslist/billing/switch-to-student';
const NOTESLIST_DOWNGRADE_FROM_DUAL_URL =
    CLOUD_FUNCTIONS_BASE + '/integrations/noteslist/billing/downgrade-from-dual';
const NOTESLIST_CANCEL_PENDING_DOWNGRADE_URL =
    CLOUD_FUNCTIONS_BASE + '/integrations/noteslist/billing/cancel-pending-downgrade';
const NOTESLIST_SUBSCRIPTION_PERIOD_END_URL =
    CLOUD_FUNCTIONS_BASE + '/integrations/noteslist/billing/subscription-period-end';
const NOTESLIST_BUNDLE_ELIGIBILITY_URL =
    CLOUD_FUNCTIONS_BASE + '/integrations/noteslist/billing/bundle-eligibility';
const NOTESLIST_SYNC_ACCESS_URL =
    CLOUD_FUNCTIONS_BASE + '/integrations/noteslist/sync-access';
const NOTESLIST_LINK_ACCESS_URL =
    CLOUD_FUNCTIONS_BASE + '/integrations/noteslist/link-access';
const NOTESLIST_AFFILIATE_SEATS_SYNC_URL =
    CLOUD_FUNCTIONS_BASE + '/integrations/noteslist/affiliate-seats/sync';
const NOTESLIST_ROSTER_SYNC_URL =
    CLOUD_FUNCTIONS_BASE + '/integrations/noteslist/roster/sync';
const UPDATE_ADDITIONAL_LICENSES_URL = CLOUD_FUNCTIONS_BASE + '/update-additional-licenses';
const CONFIRM_ADDITIONAL_LICENSES_URL = CLOUD_FUNCTIONS_BASE + '/confirm-additional-licenses';

const NOTESLIST_APP_URL = process.env.VUE_APP_NOTESLIST_APP_URL || 'https://thenoteslist.app';
const NOTESLIST_INTEGRATION_ENABLED = process.env.VUE_APP_NOTESLIST_INTEGRATION_ENABLED === 'true';
const NOTESLIST_INTEGRATION_BILLING_ENFORCED =
    process.env.VUE_APP_NOTESLIST_INTEGRATION_BILLING_ENFORCED === 'true';


export {
    BACKEND_API_HOST,
    CLOUD_FUNCTIONS_BASE,
    SAMPLE_PROJECT_PATH,
    SAMPLE_POSTER_PATH,
    PROJECT_CREATE_SAMPLE_URL,
    PROJECT_DELETE_PAGES_URL,
    PROJECT_ADD_PAGES_URL,
    PROJECT_REPLACE_PAGES_URL,
    PROJECT_CREATE_VERSION_URL,
    PROJECT_PROMOTE_VERSION_URL,
    SUBSCRIBE_PLAN_URL,
    CANCEL_PLAN_URL,
    CANCEL_PLAN_UNDO_URL,
    UPDATE_SUBSCRIPTION_URL,
    UPDATE_CARD_URL,
    UPDATE_EMAIL_URL,
    CHECK_PROMOCODE_URL,
    GET_INVOICES_URL,
    NOTESLIST_INTEGRATION_LINK_URL,
    NOTESLIST_INTEGRATION_UNLINK_URL,
    NOTESLIST_INTEGRATION_STATUS_URL,
    NOTESLIST_ACCOUNT_STATUS_URL,
    NOTESLIST_ACCOUNT_START_URL,
    NOTESLIST_ACCOUNT_UNLINK_URL,
    NOTESLIST_PRODUCTIONS_URL,
    NOTESLIST_RESYNC_URL,
    NOTESLIST_NOTIFY_STRUCTURE_URL,
    NOTESLIST_UPGRADE_TO_DUAL_URL,
    NOTESLIST_PREVIEW_SWITCH_URL,
    NOTESLIST_APPLY_SWITCH_URL,
    NOTESLIST_CONFIRM_SWITCH_URL,
    NOTESLIST_SWITCH_CUELIST_INTERVAL_URL,
    NOTESLIST_SWITCH_TO_STUDENT_URL,
    NOTESLIST_DOWNGRADE_FROM_DUAL_URL,
    NOTESLIST_CANCEL_PENDING_DOWNGRADE_URL,
    NOTESLIST_SUBSCRIPTION_PERIOD_END_URL,
    NOTESLIST_BUNDLE_ELIGIBILITY_URL,
    NOTESLIST_SYNC_ACCESS_URL,
    NOTESLIST_LINK_ACCESS_URL,
    NOTESLIST_AFFILIATE_SEATS_SYNC_URL,
    NOTESLIST_ROSTER_SYNC_URL,
    UPDATE_ADDITIONAL_LICENSES_URL,
    CONFIRM_ADDITIONAL_LICENSES_URL,
    NOTESLIST_APP_URL,
    NOTESLIST_INTEGRATION_ENABLED,
    NOTESLIST_INTEGRATION_BILLING_ENFORCED
};


// WEBPACK FOOTER //
// ./src/lib/URLs.js